import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { getDepartments } from '../../services/firebase/departmentService';

const DepartmentFilter = ({ value, onChange }) => {
  const [flatList, setFlatList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const flattenDepartments = (depts, level = 0) => {
    return depts.flatMap(dept => [
        { 
            ...dept, 
            displayName: "\u00A0\u00A0\u00A0\u00A0".repeat(level) + (level > 0 ? "└── " : "") + dept.name 
        },
        ...(dept.children ? flattenDepartments(dept.children, level + 1) : [])
    ]);
  };

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const response = await getDepartments({ hierarchical: true, status: 'active' });
      const depts = response.data || response || [];
      const flattened = Array.isArray(depts) ? flattenDepartments(depts) : [];
      setFlatList(flattened);
      setDepartments(depts);
    } catch (error) {
      console.error('Error fetching departments:', error);
      setFlatList([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form.Select
      size="sm"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ width: 'auto', maxWidth: '100%' }}
      disabled={loading}
    >
      <option value="">All Departments</option>
      {loading ? (
        <option disabled>Loading...</option>
      ) : (
        flatList.map((dept) => (
          <option key={dept.code} value={dept.code}>
            {dept.displayName}
          </option>
        ))
      )}
    </Form.Select>
  );
};

export default DepartmentFilter;
